import { useTranslation } from '@mint-lib/i18n';
import { Card, Chip, typographyVariants } from '@mint-lib/tw-components';

import { CHANNELS_AND_CATEGORIES } from '../../../constants/ComponentsConstants.jsx';
import { snakeCaseToCamelCase } from '../../../utils/snakeCaseToCamelCase.js';

type Props = {
  channels: string[];
};

const ChannelCard = ({ channels }: Props) => {
  const { t } = useTranslation('@myn/integrations_v2');

  if (!channels.length) {
    return null;
  }

  const sortedChannels = channels
    .toSorted((a, b) => a.localeCompare(b))
    .map((channel) => CHANNELS_AND_CATEGORIES[snakeCaseToCamelCase(channel)]);

  return (
    <Card className="w-full p-2">
      <div className="mb-4">
        <h4 className={typographyVariants({ variant: 'h4' })}>
          {t('Supported channels')}
        </h4>
      </div>
      <div className="flex flex-wrap gap-2">
        {sortedChannels.map((channelData) => (
          <Chip color={'silver'} variant="outline" key={channelData.label}>
            {channelData?.chipProps?.iconComponent}
            {channelData?.label}
          </Chip>
        ))}
      </div>
    </Card>
  );
};

export default ChannelCard;
